import React from "react";
import { FileDownloadOutlined } from "@mui/icons-material";
import { wholeNumberWithCommas } from "../utils/NumberFormatter";
import DownloadErrors from "./DownloadErrors";
import FileIcon from "./shared/FileIcon";
import TruncatedText from "./shared/TruncatedText";

const FileStats = ({ submissions, submissionType, onViewFile }) => {
  return (
    <div className="file_stats__table-container">
      <table className="summary_table summary_table--rounded">
        <thead>
          <tr>
            <th>File</th>
            <th>Selected Rows</th>
            <th>Invalid NDCs</th>
            <th>Rows for Submission</th>
            <th>Validation Alerts</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {submissions.map((s) => {
            const { summary } = s;
            return (
              <tr key={s.fileId}>
                <td>
                  <div className="file_stats">
                    <div className="file_stats__img">
                      <FileIcon />
                    </div>
                    <div className="file_stats__text">
                      <TruncatedText
                        text={s.filename || "File"}
                        className="file_stats__text__title__wrapper"
                      />
                      <div className="file_stats__text__subtitle">{`${wholeNumberWithCommas(summary.original)} rows`}</div>
                    </div>
                  </div>
                </td>
                <td>{wholeNumberWithCommas(summary.rows || 0)}</td>
                <td>{wholeNumberWithCommas(s.excludedRows)}</td>
                <td>{wholeNumberWithCommas(summary.valid || 0)}</td>
                <td>{wholeNumberWithCommas(summary.invalid || 0)}</td>
                <td>
                  <div className="flex justify-content-end gap--8">
                    <DownloadErrors
                      submissionType={submissionType}
                      attachments={[s]}
                      className="button button--md button--white button--pad-sm"
                      label={
                        <>
                          <FileDownloadOutlined style={{ fontSize: "14px", marginRight: "4px" }} />
                          <span>Alerts</span>
                        </>
                      }
                    />
                    <button
                      className="button button--md button--white button--pad-sm"
                      onClick={() => onViewFile(s.fileId)}
                    >
                      <span>View File</span>
                    </button>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default FileStats;
